// extracted by mini-css-extract-plugin
module.exports = {"addressInfo":"Taxes_addressInfo__3_Vk6","state":"Taxes_state__3BGLe","controlGroup":"Taxes_controlGroup__2nPrO","footer":"Taxes_footer__CEVb0"};